import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Grid, FolderHeart, HelpCircle, ShieldCheck, LayoutDashboard, Newspaper, FileText, GraduationCap } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

export default function BottomNav() {
  const location = useLocation();
  const { user, isAdmin } = useAuth();
  
  const navItems = [
    { name: 'Beranda', path: '/', icon: Home },
    { name: 'Layanan', path: '/services', icon: Grid },
    { name: 'Produk', path: '/products', icon: FolderHeart },
    { name: 'Edukasi', path: '/education', icon: GraduationCap },
    { name: 'Regulasi', path: '/regulations', icon: FileText },
    { name: 'Artikel', path: '/articles', icon: Newspaper },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t border-border shadow-[0_-4px_16px_rgba(0,0,0,0.05)] pb-safe mb-0 ring-1 ring-border/5">
      <div className="flex items-center justify-around h-16 px-1">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          return (
            <Link
              key={item.name}
              to={item.path}
              className={`relative flex flex-col items-center justify-center w-full h-full space-y-1 transition-all duration-300 ${
                isActive ? 'text-primary' : 'text-foreground/60 hover:text-foreground/80'
              }`}
            >
              <div className={`relative flex items-center justify-center p-1.5 rounded-full transition-all duration-300 ${isActive ? 'bg-primary/10 text-primary scale-110' : 'text-foreground/60'}`}>
                <Icon strokeWidth={isActive ? 2.5 : 2} className="h-5 w-5 transition-transform" />
              </div>
              <span className={`text-[9px] font-black uppercase tracking-widest text-center ${isActive ? 'text-primary' : 'text-foreground/60'}`}>
                {item.name}
              </span>
              {isActive && (
                <motion.div 
                  layoutId="activeNavMobile"
                  className="absolute bottom-0 w-full h-0.5 bg-primary shadow-sm shadow-primary/20"
                />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
